export default {
      id: "water-level-usage",
      viewBox: "0 0 11.457 11.405",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#water-level",
      toString: function () {
        return this.url;
      }
    }